/**
 * Bounds of a `CompanyTag` (`../types/company-tag.ts`): what a chat marker may
 * carry and `POST /company/preview` accepts.
 *
 * This file is consumed by `@shaarp/ui`. `@shaarp/api` cannot import a runtime
 * value from this package (its barrel re-exports a directory, which Node
 * refuses to resolve from the API's CommonJS build), so it keeps a mirrored
 * copy in `api/src/common/constants/company-tag.ts`, held to this one by
 * `api/src/common/utils/company-tag.spec.ts`. Keep both in sync: a UI that
 * accepts a longer value than the API sends a tag the API refuses.
 */

/** Longest value of each free-text attribute of a tag. */
export const COMPANY_TAG_LIMITS = {
  id: 64,
  name: 200,
  city: 100,
  address: 200,
  siret: 32,
  siren: 32,
  domain: 253,
  linkedin: 300,
  activity: 200,
} as const;

/** Longest `brief` a tag carries. */
export const COMPANY_TAG_BRIEF_MAX_LENGTH = 300;

/** Most `source` pages a tag carries. */
export const COMPANY_TAG_MAX_SOURCES = 3;

/** Longest URL of a `source` page. */
export const COMPANY_TAG_SOURCE_URL_MAX_LENGTH = 2000;

/**
 * Most tags one `POST /companies/from-tags` saves: a chat table is sent in
 * batches of this many, each answered within a minute or so — the list fills
 * batch by batch, and a deploy cuts at most one batch.
 */
export const COMPANY_FROM_TAGS_BATCH_MAX = 10;
